import { withMotion } from '@hoc/withMotion';
import { ReactComponent as SvgArrowRight } from '@img/icons/arrow-right.svg';
import { ReactComponent as SvgHeaderLogo } from '@img/logos/header-logo.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import Navigation from '@stories/Components/Navigation/Navigation';
import NavigationMobile from '@stories/Components/NavigationMobile/NavigationMobile';
import { Divide as Hamburger } from 'hamburger-react';
import * as React from 'react';
import { useEffect } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import S from './Header.styles';
const SCROLL_THRESHOLD = 50;
const Header = ({ autoHide = false, cta, navigation, themeOption: initialThemeOption = 'light', transparent = false, }) => {
    const [activeNavigationId, setActiveNavigationId] = React.useState('');
    const [hasScrolled, setHasScrolled] = React.useState(false);
    const [isMobileNavActive, setIsMobileNavActive] = React.useState(false);
    const [isDesktopNavigationActive, setIsDesktopNavigationActive] = React.useState(false);
    const headerRef = React.useRef(null);
    useEffect(() => {
        // eslint-disable-next-line
        function handleClickOutside(event) {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setIsDesktopNavigationActive(false);
                setActiveNavigationId('');
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [headerRef]);
    useIsomorphicLayoutEffect(() => {
        // Check window scroll position on load.
        if (window.scrollY > SCROLL_THRESHOLD) {
            setHasScrolled(true);
        }
        // Hook up event handlers for future scrolling.
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const reduced = !autoHide && hasScrolled;
    const hidden = autoHide && hasScrolled;
    let themeOption = initialThemeOption;
    if (!isMobileNavActive && transparent) {
        themeOption = 'dark';
    }
    if (!isMobileNavActive && (reduced || !!activeNavigationId)) {
        themeOption = 'light';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { ref: headerRef, reduced: reduced, themeOption: themeOption, transparent: transparent && !activeNavigationId, visible: !hidden },
            React.createElement(S.Inner, null,
                React.createElement(S.LogoLink, { href: "/" },
                    React.createElement(S.Logo, { as: SvgHeaderLogo, "aria-label": "Real Estate Management (UK) Limited" })),
                React.createElement(Navigation, { activeId: activeNavigationId, items: navigation, setActiveId: setActiveNavigationId, setIsDesktopNavigationActive: setIsDesktopNavigationActive }),
                cta?.text && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { href: cta.url, icon: SvgArrowRight, target: cta.target, themeOption: themeOption === 'light' ? 'purple' : 'white', title: cta.text }))),
                React.createElement(Hamburger, { label: isMobileNavActive ? 'Close Navigation' : 'Open Navigation', toggled: isMobileNavActive, toggle: setIsMobileNavActive }))),
        React.createElement(S.Overlay, { "aria-hidden": true, "data-active": isDesktopNavigationActive }),
        React.createElement(NavigationMobile, { cta: cta, items: navigation, themeOption: themeOption, visible: isMobileNavActive })));
    function onScroll() {
        setHasScrolled(window.scrollY > SCROLL_THRESHOLD);
    }
};
export default withMotion(Header);
